import React from 'react';
import Modal from '../../components/Utils/ModalShow';
import { FaSignOutAlt } from 'react-icons/fa';

const LogoutModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Confirmation de déconnexion"
      headerIcon={<FaSignOutAlt className="text-xl text-[--color-primary]" />}
      size={400}
      footer={
        <>
          <button 
            onClick={onCancel}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
          >
            Annuler
          </button>
          <button 
            onClick={onConfirm}
            className="px-4 py-2 bg-[--color-primary] text-white rounded-md hover:bg-[--color-orange] transition-colors"
          >
            Déconnexion
          </button>
        </>
      }
    >
      <div className="p-6">
        <p className="text-gray-700">Êtes-vous sûr de vouloir vous déconnecter ?</p>
      </div>
    </Modal>
  );
};

export default LogoutModal;